import { z } from "zod";

import { TEXT_NOTE_LENGTH } from "~/common/constants";
import {
  mentalStatusExaminationSchema,
  mentalStatusExaminationSchemaRequired,
} from "~/providers/utils/consultationRequests/schemas";

export const saveSessionSoapNoteSchema = mentalStatusExaminationSchema.extend({
  subjective: z
    .string()
    .max(
      TEXT_NOTE_LENGTH,
      `Please limit subjective note to ${TEXT_NOTE_LENGTH} characters.`,
    )
    .optional(),
  diagnostic_considerations: z
    .string()
    .max(
      TEXT_NOTE_LENGTH,
      `Please limit diagnostic considerations to ${TEXT_NOTE_LENGTH} characters.`,
    )
    .optional(),
  diagnosis_codes: z.string().optional(),
  treatment_plan: z
    .string()
    .max(
      TEXT_NOTE_LENGTH,
      `Please limit treatment plan to ${TEXT_NOTE_LENGTH} characters.`,
    )
    .optional(),
  cpt_codes: z.string().optional(),
});

export const sessionSoapNoteCompleteSchema =
  mentalStatusExaminationSchemaRequired.extend({
    subjective: z
      .string()
      .min(1, "Please enter a subjective note.")
      .max(
        TEXT_NOTE_LENGTH,
        `Please limit subjective note to ${TEXT_NOTE_LENGTH} characters.`,
      ),
    diagnostic_considerations: z
      .string()
      .min(1, "Please enter observations and diagnostic considerations.")
      .max(
        TEXT_NOTE_LENGTH,
        `Please limit diagnostic considerations to ${TEXT_NOTE_LENGTH} characters.`,
      ),
    diagnosis_codes: z.string().optional(),
    treatment_plan: z
      .string()
      .min(1, "Please enter treatment plan.")
      .max(
        TEXT_NOTE_LENGTH,
        `Please limit treatment plan to ${TEXT_NOTE_LENGTH} characters.`,
      ),
    cpt_codes: z.string().optional(),
  });

export const sessionSoapNoteFormSchema = z.discriminatedUnion(
  "completeAndSign",
  [
    z.object({
      completeAndSign: z.literal(false),
      data: saveSessionSoapNoteSchema,
    }),
    z.object({
      completeAndSign: z.literal(true),
      data: sessionSoapNoteCompleteSchema,
    }),
  ],
);

export type SessionSoapNoteFormInput = z.input<
  typeof sessionSoapNoteFormSchema
>;
export type SessionSoapNoteFormValues = z.infer<
  typeof sessionSoapNoteFormSchema
>;
